import { createSlice } from '@reduxjs/toolkit';

import type { ArbitroNomeacoesState, Nomeacao } from '@/types/arbitral/nomeacaoTypes';

import { aceitarNomeacao, fetchNomeacoes, recusarNomeacao } from './actions';

const initialState: ArbitroNomeacoesState = {
  items: [],
  loading: false,
  acting: false,
  error: null,
};

const upsert = (items: Nomeacao[], updated: Nomeacao): Nomeacao[] =>
  items.map((item) => (item.id === updated.id ? updated : item));

const arbitroNomeacoesSlice = createSlice({
  name: 'arbitroNomeacoes',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNomeacoes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNomeacoes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchNomeacoes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(aceitarNomeacao.pending, (state) => {
        state.acting = true;
        state.error = null;
      })
      .addCase(aceitarNomeacao.fulfilled, (state, action) => {
        state.acting = false;
        state.items = upsert(state.items, action.payload);
      })
      .addCase(aceitarNomeacao.rejected, (state, action) => {
        state.acting = false;
        state.error = action.payload as string;
      })
      .addCase(recusarNomeacao.pending, (state) => {
        state.acting = true;
        state.error = null;
      })
      .addCase(recusarNomeacao.fulfilled, (state, action) => {
        state.acting = false;
        state.items = upsert(state.items, action.payload);
      })
      .addCase(recusarNomeacao.rejected, (state, action) => {
        state.acting = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = arbitroNomeacoesSlice.actions;
export default arbitroNomeacoesSlice.reducer;
